import { restrictions } from '../constants/tags';

export const validate = (tag) => {
    if (!tag?.tag_name || tag.tag_name.trim().length <= 0) {
        return false;
    }

    if (tag.tag_name.trim().length > restrictions.MAX_NAME_LENGTH) {
        return false;
    }

    let csvInjectionMatchResult = tag.tag_name.match('[\\+\\=@\\-]');
    if (csvInjectionMatchResult && csvInjectionMatchResult['index'] === 0) {
        return false;
    }

    return true;
};
